var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTractionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22.25H3.5C3.36614 22.25 3.25 22.1339 3.25 22C3.25 21.8661 3.36614 21.75 3.5 21.75H21.5C21.6339 21.75 21.75 21.8661 21.75 22C21.75 22.1339 21.6339 22.25 21.5 22.25Z",
    fill: "#0063F6",
    stroke: "#0063F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.88086H6.1C6.37713 8.88086 6.6 9.10026 6.6 9.38086V18.0009C6.6 18.2747 6.37386 18.5009 6.1 18.5009H4.5C4.22614 18.5009 4 18.2747 4 18.0009V9.38086C4 9.107 4.22614 8.88086 4.5 8.88086Z",
    fill: "#0063F6",
    stroke: "#0063F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 5.68945H13.3002C13.5741 5.68945 13.8002 5.9156 13.8002 6.18945V17.9995C13.8002 18.2733 13.5741 18.4995 13.3002 18.4995H11.7002C11.4263 18.4995 11.2002 18.2733 11.2002 17.9995V6.18945C11.2002 5.9156 11.4263 5.68945 11.7002 5.68945Z",
    fill: "#0063F6",
    stroke: "#0063F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5004 2H18.9004C18.3504 2 17.9004 2.45 17.9004 3V18C17.9004 18.55 18.3504 19 18.9004 19H20.5004C21.0504 19 21.5004 18.55 21.5004 18V3C21.5004 2.45 21.0504 2 20.5004 2Z",
    fill: "#0063F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractionActive);
export default __webpack_public_path__ + "static/media/traction-active.dbb245aadb774227a4538e1081448234.svg";
export { ForwardRef as ReactComponent };